/**
 * Forces JavaScript to wait to execute the passed in function until it finishes its current thread.
 * Useful once in a while to prevent React from batching setStates.
 */
export const nextThread = (functionToQueue: () => void): void => {
	setTimeout(() => {
		functionToQueue()
	}, 1)
}
